/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ManagerControllerDtoManagerSecedeRequest model module.
 * @module model/ManagerControllerDtoManagerSecedeRequest
 * @version 1.0
 */
class ManagerControllerDtoManagerSecedeRequest {
    /**
     * Constructs a new <code>ManagerControllerDtoManagerSecedeRequest</code>.
     * @alias module:model/ManagerControllerDtoManagerSecedeRequest
     * @param managerNo {Number} 
     */
    constructor(managerNo) { 
        
        ManagerControllerDtoManagerSecedeRequest.initialize(this, managerNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, managerNo) { 
        obj['managerNo'] = managerNo;
    }

    /**
     * Constructs a <code>ManagerControllerDtoManagerSecedeRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerControllerDtoManagerSecedeRequest} obj Optional instance to populate.
     * @return {module:model/ManagerControllerDtoManagerSecedeRequest} The populated <code>ManagerControllerDtoManagerSecedeRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerControllerDtoManagerSecedeRequest();

            if (data.hasOwnProperty('managerNo')) {
                obj['managerNo'] = ApiClient.convertToType(data['managerNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerControllerDtoManagerSecedeRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerControllerDtoManagerSecedeRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ManagerControllerDtoManagerSecedeRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

ManagerControllerDtoManagerSecedeRequest.RequiredProperties = ["managerNo"];

/**
 * @member {Number} managerNo
 */
ManagerControllerDtoManagerSecedeRequest.prototype['managerNo'] = undefined;






export default ManagerControllerDtoManagerSecedeRequest;

